// extracted by mini-css-extract-plugin
export default {"BodyPartPicker":"EmVf5QpqwgBrIKcIznz3","ButtonGroup":"oGWkPbLHrzAFDcFjRqDB"};